export const STEP_IDS = {
  EXPERIENCE_SELECTION: 'experience-selection',
  VIEWS_MANAGER: 'views-manager',
  SEARCHBOX_CONFIG: 'searchbox-config',
  RESULTS_CONFIG: 'results-config',
  SEARCHBOX_SELECTORS: 'searchbox-selectors',
  RESULTS_SELECTOR: 'results-selector',
  THEME_EDITOR: 'theme-editor',
  SUMMARY: 'summary',
};
